module.exports = __webpack_public_path__ + "media/images/eyecatch-refund-2633db1f011b2837777ea6bb5a3b4a04.svg";